import { Rate as RateAD } from 'antd';
import cn from 'classnames';
import type React from 'react';

import styles from './rate.module.css';

type P = React.ComponentProps<typeof RateAD>;

const Rate = ({ className, ...rest }: P) => <RateAD className={cn(styles.rate, className)} {...rest} />;

export default Rate;
